import { types } from './actions';
import { APPROVED, UNAPPROVED, FINALIZED } from './constants';

/* FIXME: set state consts here and import where needed */

const initalState = {
  userBonusMonthId: null,
  bonusMonth: null,
  supervisorId: 0,
  userId: 0,
  userIdState: UNAPPROVED,
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.SET_USER_MONTH_BONUS_ID: {
      const { userBonusMonthId } = action;
      return {
        ...state,
        userBonusMonthId,
      };
    }

    case types.SET_BONUS_MONTH: {
      const { bonusMonth } = action;
      return {
        ...state,
        bonusMonth,
      };
    }

    case types.SET_SUPERVISOR_ID: {
      const { supervisorId } = action;
      return {
        ...state,
        supervisorId,
        userId: 0,
        userBonusMonthId: null,
      };
    }

    case types.SET_USER_ID: {
      const { userId } = action;
      return {
        ...state,
        userId,
      };
    }

    case types.SET_USER_ID_STATE: {
      const { userIdState } = action;
      return {
        ...state,
        userIdState,
      };
    }

    default:
      return state;
  }
};

export default reducer;
